module.exports = __webpack_public_path__ + "static/media/icn-download-report.7f378ff5.svg";